import { FaGithub, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { SiMalt } from "react-icons/si";

export const aboutMe = {
  name: "Jeff LEFLOCH",
  title: "Développeur Full Stack",
  bio: "Passionné par l'innovation et la création d'expériences web performantes, j'accompagne les entreprises dans la conception et l'optimisation de leurs plateformes digitales. Avec plus de 13 ans d'expérience, j'ai développé une expertise en Next.js, React, TypeScript & PHP pour concevoir des architectures robustes et scalables.",
  strengths: [
    "Lead Tech & mentor – J'accompagne les équipes dans l'adoption de bonnes pratiques et la mise en place d'architectures modernes.",
    "Performance & UX – Optimisation des performances, SEO et accessibilité pour des applications web fluides et engageantes.",
    "Entrepreneuriat & innovation – Je m'implique dans des projets ambitieux et explore des modèles business innovants, notamment via ma société et des investissements stratégiques.",
  ],
  note: "Toujours en veille sur les nouvelles technologies et tendances du web, j'aime partager mes connaissances et échanger avec la communauté tech.",
  location: "Angers, France",
  email: "lefloch.jf@gmail.com",
  availability: "Disponible pour de nouvelles opportunités",
  interests: [
    "Développement web",
    "UX/UI Design",
    "Open Source",
    "Intelligence Artificielle",
    "Nouvelles technologies",
    "Sport",
    "Voyages",
    "Échecs",
    "Jeux Video",
  ],
  personalQualities: ["Créatif", "Rigoureux", "Autonome", "Curieux", "Esprit d'équipe"],
  socialLinks: {
    github: {
      url: "https://github.com/katsenkatorz",
      icon: <FaGithub className="h-full w-full" />,
      label: "GitHub",
    },
    linkedin: {
      url: "https://linkedin.com/in/lefloch-jean-françois",
      icon: <FaLinkedinIn className="h-full w-full" />,
      label: "LinkedIn",
    },
    twitter: {
      url: "https://twitter.com/katsenkatorz",
      icon: <FaXTwitter className="h-full w-full" />,
      label: "Twitter",
    },
    instagram: {
      url: "https://www.instagram.com/katsenkatorz",
      icon: <FaInstagram className="h-full w-full" />,
      label: "Instagram",
    },
    malt: {
      url: "https://www.malt.fr/profile/jeanfrancoislefloch",
      icon: <SiMalt className="h-full w-full" />,
      label: "Malt",
    },
  },
  languages: [
    { name: "Français", level: "Natif", emoji: "🇫🇷" },
    { name: "Anglais", level: "Compétence professionnelle", emoji: "🇬🇧" },
  ],
};
